var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"tab-element sticky action",class:{ right: _vm.side === 'right', left: _vm.side === 'left', tiny: _vm.tiny },staticStyle:{"background-color":"rgb(246, 246, 252)"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }